function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { group } from "d3-array";
/**
    @summary Extends the base behavior of d3.nest to allow for multiple depth levels.
    @param keys An array of key accessors that signify each nest level.
    @private
*/ export default function(data, keys) {
    if (!_instanceof(keys, Array)) keys = [
        keys
    ];
    var nestedData = nestGroups(data, keys);
    return bubble(nestedData);
}
/**
    Recursively groups data by each key function, producing {key, values} objects compatible with d3-hierarchy.
    @param data The flat data array to nest.
    @param fns An array of key accessor functions, one per nesting level.
*/ export function nestGroups(data, fns) {
    if (!fns.length) return data;
    return _to_consumable_array(group(data, fns[0])).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], values = _param[1];
        return {
            key: key,
            values: nestGroups(values, fns.slice(1))
        };
    });
}
/**
    Bubbles up values that do not nest to the furthest key.
    @param values The "values" of a nest object.
    @private
*/ function bubble(values) {
    return values.map(function(d) {
        if (d.key && d.values) {
            if (d.values[0].key === "undefined") return d.values[0].values[0];
            else d.values = bubble(d.values);
        }
        return d;
    });
}

//# sourceMappingURL=nest.js.map